import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import './assets/scss/app.scss'
import axios from 'axios';
import Snotify from 'vue-snotify'
import 'vue-snotify/styles/material.css'; // or dark.css or simple.css


//---------SETUP NOTIFICATIONS------------//
Vue.use(Snotify);


Vue.use(Buefy);


if( localStorage.sessionId == undefined){
  localStorage.sessionId = Math.random().toString(36).substring(2);
}
var sessionId = localStorage.sessionId;
if(window.location.hostname == 'localhost'){
  axios.defaults.baseURL = 'http://localhost:8888/woodburn-unlimited/api/v1/'
}
else{
  axios.defaults.baseURL = window.location.protocol + "//" + window.location.hostname + '/api/v1/';
}

axios.defaults.headers.common['Session-Id'] = sessionId ;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.patch['Content-Type'] = 'application/json'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
